import './index-checkout.global.scss';
